import React, { useEffect, useMemo, useState } from "react";
import { getPropsDataGrid } from "../../../utils/default-props";
import { getDataGridCustomToolbarCaption } from "../../../components/default-components/data-grid-custom-toolbar";
import { useNavigate } from "react-router-dom";
import { Button, DataGrid } from "devextreme-react";
import { Column, Editing, Toolbar, Item, RequiredRule, Lookup } from "devextreme-react/data-grid";
import { usePublicEvents } from "../../../contexts/public-events";
import { useAuth } from "../../../contexts/auth";
import LoaderPage from "../../../layouts/loader-page/loader-page";
import { useDataSource } from "../../../contexts/dataSource";
import { passportStatusTypes, travelInsturanceStatusTypes, vaccinationStatusTypes } from "../../../utils/lookup-groups.ts";



function TravelList() {

    const loading = false;
    const navigate = useNavigate();
    const { setPublicAddEvent } = usePublicEvents() || {};
    const { user } = useAuth() || {};
    const { dataSourceHR } = useDataSource()


    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeTravelPlan`,
    }), [user])

    const employeeDataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/Employee/ComboList`,
        loadMode: "raw"
    }), [user])

    const dbEmployeeTravelAccommodation = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeTravelAccommodation`,
        loadMode: "raw"
    }), [user])

    const dbEmployeeTravelTransport = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeTravelTransport`,
        loadMode: "raw"
    }), [user])

    const dbTravelPassportStatusTypes = useMemo(() => dataSourceHR({
        loadUrl: `/api/LookupData/LookupGroup/` + passportStatusTypes.id,
        loadMode: "raw"
    }), [user])

    const dbTravelInsuranceStatusDataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/LookupData/LookupGroup/` + travelInsturanceStatusTypes.id,
        loadMode: "raw"
    }), [user])

    const dbVaccinationStatusDataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/LookupData/LookupGroup/` + vaccinationStatusTypes.id,
        loadMode: "raw"
    }), [user])


    const dateEditorOption = {
        type: "datetime",
        // placeholder: "12/31/2018 00:00",
        showClearButton: true,
        //inputAttr=dataTimeLabel
        useMaskBehavior: true,
        // displayFormat="EEEE, d of MMM, yyyy HH:mm",
        displayFormat: "dd.MM.yyyy HH:mm",
        //dateSerializationFormat: "yyyy-MM-dd"

    }

    const handleRowDblClick = (e) => {
        if (e.data?.id) {
            navigate(`/travel/travel-card`);
        }
    };

    const handleApproveClick = (id) => {
        navigate(`/travel/travel-card`);
    };

    useEffect(() => {
        if (setPublicAddEvent) {
            setPublicAddEvent(() => () => navigate("/travel/travel-card"));
        }
        return () => {
            if (setPublicAddEvent) {
                setPublicAddEvent(undefined);
            }
        };
    }, [setPublicAddEvent, navigate]);

    return (
        <LoaderPage loading={loading}>
            <div className="content-block">
                <div className="dx-card responsive-paddings">
                    <DataGrid
                        {...getPropsDataGrid}
                        dataSource={dataSource}
                        onRowDblClick={handleRowDblClick}
                        showBorders={true}
                        columnAutoWidth={true}
                        rowAlternationEnabled={true}
                        hoverStateEnabled={true}
                        keyExpr="id"
                        searchPanel={{ visible: true }}
                    >
                        <Toolbar>
                            {getDataGridCustomToolbarCaption("Seyahat Talepleri")}
                            <Item name="searchPanel" showText="always" />
                        </Toolbar>


                        {/* <Column dataField="employeeTravelPurposeId" caption="Seyahat Amacı">
                            <Lookup dataSource={purposeDb} valueExpr="id" displayExpr="name" />
                        </Column> */}

                        <Column dataField="employeeId" caption="Personel" >
                            <Lookup dataSource={employeeDataSource} valueExpr="id" displayExpr="text" />
                            <RequiredRule />
                        </Column>

                        <Column dataField="fromWhere" caption="Nereden" ></Column>
                        <Column dataField="toWhere" caption="Nereye" ></Column>

                        <Column dataField="startDate" caption="Seyahat Başlangıç"
                            editorType="dxDateBox"
                            editorOptions={dateEditorOption}
                            dataType="datetime"
                            format="shortDateShortTime" />

                        <Column dataField="endDate" caption="Seyahat Bitiş"
                            editorType="dxDateBox"
                            editorOptions={dateEditorOption}
                            dataType="datetime"
                            format="shortDateShortTime" />
                        <Column
                            dataField="employeeTravelTransportId"
                            caption="Ulaşım Türü"
                            editorType="dxSelectBox"
                        >
                            <Lookup
                                dataSource={dbEmployeeTravelTransport}
                                valueExpr="id"
                                displayExpr="name"
                            />
                        </Column>
                        <Column
                            dataField="employeeTravelAccommodationId"
                            caption="Konaklama"
                            editorType="dxSelectBox"
                        >
                            <Lookup
                                dataSource={dbEmployeeTravelAccommodation}
                                valueExpr="id"
                                displayExpr="name"
                            />
                        </Column>

                        <Column
                            dataField="businessAdvance"
                            caption="İş Avansı">

                        </Column>

                        <Column
                            dataField="travelInsuranceStatusTypeId"
                            caption="Sigorta"
                            editorType="dxSelectBox"
                        >
                            <Lookup
                                dataSource={dbTravelInsuranceStatusDataSource}
                                valueExpr="id"
                                displayExpr="text"
                            />
                        </Column>

                        <Column
                            dataField="vaccinationStatusTypeId"
                            caption="Aşı"
                            editorType="dxSelectBox"
                        >
                            <Lookup
                                dataSource={dbVaccinationStatusDataSource}
                                valueExpr="id"
                                displayExpr="text"
                            />
                        </Column>

                        <Column
                            dataField="passportStatusTypeId"
                            caption="Pasaport"
                            editorType="dxSelectBox"
                        >
                            <Lookup
                                dataSource={dbTravelPassportStatusTypes}
                                valueExpr="id"
                                displayExpr="text"
                            />
                        </Column>

                        {/* <Column dataField="approvalDate" caption="Onay Tarihi"
                            editorType="dxDateBox"
                            editorOptions={dateEditorOption}
                            dataType="datetime"
                            format="shortDateShortTime" /> */}

                        <Column
                            dataField="approvalStatus"
                            caption="Onay Durumu"></Column>


                        <Column
                            type="buttons"
                            caption="İşlemler"
                            width={150}
                            buttons={[
                                {
                                    hint: "Düzenle",
                                    icon: "edit",
                                    name: "edit",
                                },
                                {
                                    hint: "Onayla",
                                    icon: "check",
                                    onClick: (e) => {
                                        handleApproveClick(e.row.data.id);
                                    },
                                },
                                {
                                    hint: "Sil",
                                    icon: "trash",
                                    name: "delete",
                                },
                            ]}
                        />

                        <Editing
                            mode="row"
                            allowUpdating={true}
                            allowDeleting={true}
                            useIcons={true}
                        />
                    </DataGrid>
                </div>
            </div>
        </LoaderPage>
    )
}

export default TravelList